<template>
    <div>
        <div class="button-group">
            <a-button @click="openStreetView">
                <environment-outlined style="padding-bottom: 8px" />
                <span style="margin: 0; line-height: normal; font-size: 12px">Street View</span>
            </a-button>
            <a-button @click="openModal('/bic?id=' + props.data.id)">
                <file-image-outlined style="padding-bottom: 8px" />
                <span style="margin: 0; line-height: normal; font-size: 12px">BIC Planta</span>
            </a-button>
            <a-button @click="openModal('/maps/properties/' + props.data.id + '/cadastral-audit')">
                <file-search-outlined style="padding-bottom: 8px" />
                <span style="margin: 0; line-height: normal; font-size: 12px">Auditoria</span>
            </a-button>
            <a-button @click="openModal('/inspections/show?id=' + props.data.id)">
                <solution-outlined style="padding-bottom: 8px" />
                <span style="margin: 0; line-height: normal; font-size: 12px">Vistoria</span>
            </a-button>
            <a-button v-if="canEmit" @click="openModal('/docs/emissao/' + props.data.id)">
                <file-text-outlined style="padding-bottom: 8px" />
                <span style="margin: 0; line-height: normal; font-size: 12px">Documentos</span>
            </a-button>
            <a-button @click="openFoto360">
                <camera-outlined style="padding-bottom: 8px" />
                <span style="margin: 0; line-height: normal; font-size: 12px">Foto 360</span>
            </a-button>
        </div>

        <!-- Informações principais -->
        <div class="data-grid">
            <div class="data-item" v-if="props.data.id">
                <span class="label">Inscrição Imobiliária:</span>
                <span class="value">{{ props.data.id }}</span>
            </div>
            <div class="data-item" v-if="props.data.refAnt">
                <span class="label">Ref Anterior:</span>
                <span class="value">{{ props.data.refAnt }}</span>
            </div>
            <div class="data-item" v-if="props.data.sector">
                <span class="label">Setor:</span>
                <span class="value">{{ props.data.sector }}</span>
            </div>
            <div class="data-item" v-if="props.data.zone">
                <span class="label">Zona Fiscal:</span>
                <span class="value">{{ props.data.zone }}</span>
            </div>
            <div class="data-item" v-if="props.data.block">
                <span class="label">Quadra:</span>
                <span class="value">{{ props.data.block }}</span>
            </div>
            <div class="data-item" v-if="props.data.address?.neighborhood">
                <span class="label">Bairro:</span>
                <span class="value">{{ props.data.address.neighborhood }}</span>
            </div>
            <div class="data-item" v-if="props.data.subdivision">
                <span class="label">Lote:</span>
                <span class="value">{{ props.data.subdivision }}</span>
            </div>
            <div class="data-item" v-if="props.data.generalSubdivision">
                <span class="label">Loteamento:</span>
                <span class="value">{{ props.data.generalSubdivision }}</span>
            </div>
            <div class="data-item" v-if="props.data.area">
                <span class="label">Área Lote (m²):</span>
                <span class="value">{{ formatArea(props.data.area) }}</span>
            </div>
            <div class="data-item" v-if="props.data.condominium">
                <span class="label">Condomínio:</span>
                <span class="value">{{ props.data.condominium }}</span>
            </div>
            <div class="data-item" v-if="props.data.areaFraction">
                <span class="label">Área Fração Lote (m²):</span>
                <span class="value">{{ formatArea(props.data.areaFraction) }}</span>
            </div>
            <div class="data-item" v-if="props.data.owner?.name">
                <span class="label">
                    Proprietário:
                    <span v-if="!!props.data.promiser" style="color:red; opacity:75%">(promitente)</span>
                </span>
                <span class="value">{{ !!props.data.promiser ? props.data.promiser.name : props.data.owner.name }}</span>
            </div>
        </div>

        <!-- Abas internas -->
        <a-tabs type="card">
            <a-tab-pane key="1" tab="Características">
                <div class="data-grid">
                    <div class="data-item" v-for="characteristic in props.data.subdivisionCharacteristics" :key="characteristic.id">
                        <div class="label">{{ characteristic.group.description }}</div>
                        <div class="value">{{ characteristic.description }}</div>
                    </div>
                </div>
            </a-tab-pane>

            <a-tab-pane key="2" tab="Testadas">
                <a-table
                    :columns="frontagesColumns"
                    :dataSource="frontages"
                    bordered
                    size="small"
                    :pagination="false"
                />
            </a-tab-pane>

            <a-tab-pane key="3" tab="Localização">
                <div class="data-grid">
                    <div class="data-item">
                        <span class="label">Setor</span>
                        <span class="value">{{ props.data.sector }}</span>
                    </div>
                    <div class="data-item">
                        <span class="label">Quadra:</span>
                        <span class="value">{{ props.data.block }}</span>
                    </div>
                    <div class="data-item">
                        <span class="label">Lote:</span>
                        <span class="value">{{ props.data.subdivision }}</span>
                    </div>
                </div>
            </a-tab-pane>

            <a-tab-pane key="4" tab="Escritura">
                <div class="data-grid">
                    <div class="data-item">
                        <span class="label">Cartório de Registro</span>
                        <span class="value">{{ props.data.propertyRegistration.notary }}</span>
                    </div>
                    <div class="data-item">
                        <span class="label">Inscrição Imobiliária:</span>
                        <span class="value">{{ props.data.propertyRegistration.idPropertyByNotary }}</span>
                    </div>
                    <div class="data-item">
                        <span class="label">Quadra:</span>
                        <span class="value">{{ props.data.propertyRegistration.block }}</span>
                    </div>
                    <div class="data-item">
                        <span class="label">Lote:</span>
                        <span class="value">{{ props.data.propertyRegistration.subdivision }}</span>
                    </div>
                </div>
            </a-tab-pane>

            <a-tab-pane key="5" tab="Observações">
                <div style="display:flex; flex-direction:column; align-items:end; padding: 0 10px">
                    <a-textarea v-model:value="newObs" :rows="10" allow-clear :auto-size="{ minRows: 10, maxRows: 10 }"
                                :readonly="!editingObs" :class="{ 'readonly-cursor': !editingObs }" />

                    <div style="display:flex; margin-top:10px; gap:10px">
                        <a-button v-if="editingObs" type="text" size="large" v-text="'Cancelar'" :disabled="loading"
                                  @click="() => { editingObs = false; newObs = props.data.obs; }" />
                        <a-button :type="editingObs ? 'primary' : 'default'" size="large" :loading="loading"
                                  :disabled="!cadPermission" @click="handleObs">
                            {{ editingObs ? 'Atualizar' : 'Editar' }}
                        </a-button>
                    </div>
                </div>
            </a-tab-pane>
        </a-tabs>
    </div>

    <ModalsContainer />
</template>

<script setup>
import {defineProps, ref, h, defineAsyncComponent, onBeforeUnmount, markRaw, onMounted, reactive} from 'vue'
import { ModalsContainer, useModal } from 'vue-final-modal'
import  DefaultFrame  from "../../../DefaultFrame.vue";
import Foto360 from "../../Foto360.vue";
import {EnvironmentOutlined, FileImageOutlined, FileSearchOutlined, SolutionOutlined, FileTextOutlined, CameraOutlined} from '@ant-design/icons-vue'
import {notification} from "ant-design-vue";
import verifySpecificFuncPermissions from "../../../../../../utils/verifySpecificFuncPermissions";
import { openNotification } from '../../../../../../utils/utilities.js';

const props = defineProps({data: Object})
const modalKey = ref(0)
const frontages = ref(props.data.frontages)
const frontagesColumns = [
    { title: 'Testada', dataIndex: 'dimension', key: 'dimension' },
    { title: 'Logradouro', dataIndex: 'street', key: 'street' },
    { title: 'Número', dataIndex: 'number', key: 'number' },
    { title: 'Complemento', dataIndex: 'complement', key: 'complement' },
    { title: 'Principal', dataIndex: 'isMain', key: 'isMain',  customRender: ({text}) => (text ? 'Sim' : 'Não') },
]

const frame = markRaw(DefaultFrame)
const foto360 = markRaw(Foto360)
const canEmit = ref(false)
const cadPermission = ref(false)
const loading = ref(false)
const editingObs = ref(false)
const newObs = ref('')

const currentRoute = ref()
const foto360ModalProps = reactive({
    matricula: null,
    embedded: true,
})

const { open, destroy } = useModal({
    keepAlive: true,
    component: defineAsyncComponent(() => import('../../../ModalDragResize.vue')),
    attrs: {
        component: frame,
        componentProps: {
            route: currentRoute
        }
    }
})

const { open: openFoto360Modal, destroy: destroyFoto360Modal } = useModal({
    keepAlive: false,
    component: defineAsyncComponent(() => import('../../../ModalDragResize.vue')),
    attrs: {
        component: foto360,
        componentProps: foto360ModalProps,
        draggable: false,
        w: 720,
        h: Math.round(window.innerHeight * 0.75),
        x: window.innerWidth - 740,
        y: 40,
    }
})

const formatArea = (area) => {
    return Number(area).toFixed(2);
}
onBeforeUnmount(() => {
    destroy()
    destroyFoto360Modal()
})

const openStreetView = () => {
    const params = new URLSearchParams()
    if (props.data?.subdivisionId != null) {
        params.set('id', String(props.data.subdivisionId))
    }
    if (props.data?.id != null) {
        params.set('property_id', String(props.data.id))
    }
    openModal(`/func/aba_street/conversao?${params.toString()}`)
}

const openModal = (route) => {
    currentRoute.value = route
    modalKey.value++
    open()
}

const openFoto360 = () => {
    foto360ModalProps.matricula = props.data.id
    modalKey.value++
    openFoto360Modal()
}

onMounted(async () => {
    // id 23 - menu de emissão de documentos
    canEmit.value = await verifyPermission(23)
    cadPermission.value = await verifySpecificFuncPermissions(1)

    newObs.value = props.data.obs
})

const handleObs = async () => {
    (editingObs.value)
        ? await saveObs()
        : editingObs.value = true
}

const saveObs = async () => {
    loading.value = true

    const formData = new FormData()
    formData.append('obs', newObs.value)
    formData.append('_method', 'PUT');

    try {
        await window.axios.post(`/api/e-cidade/subdivision/${props.data.id}/save-obs`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        })

        openNotification('success', 'Observação atualizada com sucesso!')
        editingObs.value = false
        props.data.obs = newObs.value
    } catch (error) {
        openNotification('error', 'Houve algum erro ao atualizar a observação.')
    }

    loading.value = false
}

const verifyPermission = async (menuId) => {
    return (await window.axios.get(`/api/configurations/menus/${menuId}/verify-permission-from-user`)).data.data
}
</script>

<style scoped>
.button-group {
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
    margin-bottom: 16px;
}

.button-group > * {
    display: flex;
    flex-direction: column;
    align-items: center;
    height: auto;
    padding: 0.25rem !important;
    flex: 1;
    justify-content: space-around;
}

.data-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 8px;
    padding: 8px;
    max-width: 100%;
}


.data-item {
    display: flex;
    flex-direction: column;
    padding: 4px 0;
    font-size: 14px;
}

.label {
    font-size: 12px;
    color: #888;
    font-weight: 500;
    margin-bottom: 2px;
    line-height: 1.2;
}

.value {
    font-size: 14px;
    font-weight: 600;
    line-height: 1.4;
}

::v-deep(.ant-tabs-tab) {
    min-width: 100px;
    white-space: normal;
    text-align: center;
    justify-content: center;
}

::v-deep(.readonly-cursor.ant-input) {
    cursor: copy !important;
}
</style>
